import React from 'react';
import styled from 'styled-components';
import { body1FontWeight, heading4FontSize, heading3LineHeight, screenSmMax, spacer16, spacer20, spacer32, spacer40, spacer8, spacer56, spacer48, body1FontSize, Type } from '@spotify-internal/encore-web';
import { articleMarkdown } from '../../Markdown';
import { ShareButtonsComponent } from '../../ui/ShareButtons';
import { hexToRgba } from '@mrkt/features/color-conversion';
import { getLinkStyle, ImageAspectBox } from '../../ui';
import { useT } from '@mrkt/features/i18n';
import { maxWidth } from './styleConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Article = styled.div.withConfig({
  displayName: "ArticleModule__Article",
  componentId: "sc-1ych1qx-0"
})(["padding:", ";display:flex;flex-direction:column;@media (max-width:", "){padding-left:", ";padding-right:", ";padding-bottom:", ";}"], spacer40, screenSmMax, spacer16, spacer16, spacer16);
var IntroductionWrapper = styled.div.withConfig({
  displayName: "ArticleModule__IntroductionWrapper",
  componentId: "sc-1ych1qx-1"
})(["padding-top:", ";padding-bottom:", ";max-width:", ";margin:auto;"], spacer16, spacer56, maxWidth);
var Introduction = styled(Type).attrs({
  variant: Type.heading2
}).withConfig({
  displayName: "ArticleModule__Introduction",
  componentId: "sc-1ych1qx-2"
})(["padding-top:", ";"], spacer8);
var BodyWrapper = styled.div.withConfig({
  displayName: "ArticleModule__BodyWrapper",
  componentId: "sc-1ych1qx-3"
})([""]);
export var articleTextStyle = "\n  font-size: ".concat(body1FontSize, ";\n  font-weight: ").concat(body1FontWeight, ";\n  line-height: ").concat(heading3LineHeight, ";\n");
var Body = styled.div.withConfig({
  displayName: "ArticleModule__Body",
  componentId: "sc-1ych1qx-4"
})(["padding-bottom:", ";@media (max-width:", "){padding-bottom:", ";}figcaption{text-align:left;}a{", " text-decoration:underline;}ul,ol{max-width:", ";margin:auto;padding-left:", ";}ol > li,ul > li{", " display:revert;}p{", " max-width:", ";margin:auto;}p,ul,ol{padding-bottom:", ";}h1,h2,h3,h4{margin:auto;max-width:", ";}iframe{display:block;margin:auto;max-width:", ";padding-bottom:", ";}", "{max-width:", ";margin:auto;iframe{padding-bottom:0;}}img{width:100%;}div > iframe{padding-bottom:", ";}"], spacer40, screenSmMax, spacer16, function (props) {
  return getLinkStyle(props);
}, maxWidth, spacer48, articleTextStyle, articleTextStyle, maxWidth, spacer16, maxWidth, maxWidth, spacer32, ImageAspectBox, maxWidth, spacer56);
var ArticleDetails = styled.div.withConfig({
  displayName: "ArticleModule__ArticleDetails",
  componentId: "sc-1ych1qx-5"
})(["display:flex;flex-direction:row;justify-content:space-between;padding-top:", ";@media (max-width:", "){padding-top:", ";padding-bottom:0;}"], spacer40, screenSmMax, spacer20);
var BottomSection = styled.div.withConfig({
  displayName: "ArticleModule__BottomSection",
  componentId: "sc-1ych1qx-6"
})(["max-width:", ";display:flex;flex-direction:column;margin:auto;padding-top:", ";border-top:1px solid ", ";& > p{font-size:", ";}@media (max-width:", "){padding-top:", ";padding-bottom:0;}"], maxWidth, spacer56, function (_ref) {
  var theme = _ref.theme;
  return theme.box.text;
}, heading4FontSize, screenSmMax, spacer20);
var ShareButtonContainer = styled.div.withConfig({
  displayName: "ArticleModule__ShareButtonContainer",
  componentId: "sc-1ych1qx-7"
})(["display:flex;flex-direction:column;& > div{padding-bottom:0;svg{color:", ";&:hover{color:", ";}}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.box.text;
}, function (_ref3) {
  var theme = _ref3.theme;
  return hexToRgba(theme.box.text, 0.5);
});
var AuthorDate = styled(Type).attrs({
  variant: Type.body2
}).withConfig({
  displayName: "ArticleModule__AuthorDate",
  componentId: "sc-1ych1qx-8"
})(["@media (max-width:", "){display:none;}"], screenSmMax);
export var ArticleModule = function ArticleModule(_ref4) {
  var _ref4$introduction = _ref4.introduction,
      introduction = _ref4$introduction === void 0 ? '' : _ref4$introduction,
      _ref4$body = _ref4.body,
      body = _ref4$body === void 0 ? '' : _ref4$body,
      _ref4$authorDateStrin = _ref4.authorDateString,
      authorDateString = _ref4$authorDateStrin === void 0 ? '' : _ref4$authorDateStrin,
      _ref4$initialDropcap = _ref4.initialDropcap,
      initialDropcap = _ref4$initialDropcap === void 0 ? false : _ref4$initialDropcap;
  var t = useT();
  var markDown = articleMarkdown(body, initialDropcap);
  return /*#__PURE__*/_jsxs(Article, {
    children: [/*#__PURE__*/_jsx(IntroductionWrapper, {
      children: /*#__PURE__*/_jsx(Introduction, {
        children: introduction
      })
    }), /*#__PURE__*/_jsx(BodyWrapper, {
      children: /*#__PURE__*/_jsx(Body, {
        dangerouslySetInnerHTML: {
          __html: markDown
        }
      })
    }), /*#__PURE__*/_jsxs(BottomSection, {
      children: [/*#__PURE__*/_jsx("p", {
        children: t('FRODOR_e7365a', 'Spotify for Artists helps you to develop the fanbase you need to reach your goals.', '')
      }), /*#__PURE__*/_jsxs(ArticleDetails, {
        children: [/*#__PURE__*/_jsx(AuthorDate, {
          children: authorDateString
        }), /*#__PURE__*/_jsxs(ShareButtonContainer, {
          children: [t('FRODOR_f92bd3', 'Share this story', 'Share refers to sharing on social media'), /*#__PURE__*/_jsx(ShareButtonsComponent, {})]
        })]
      })]
    })]
  });
};